import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const PENDING_BOOKING_KEY = 'glaminant_pending_booking';

const PackageCard = ({
    title,
    header,
    price,
    standardPrice,
    description,
    services,
    hasUpsell,
    packageId,
    onBook
}) => {
    const [isUpsellChecked, setIsUpsellChecked] = useState(false);

    const handleToggle = () => {
        setIsUpsellChecked(!isUpsellChecked);
    };

    const ADDON_PRICE = 29;
    const ADDON_VALUE = 50;
    const finalPrice = isUpsellChecked ? price + ADDON_PRICE : price;
    const finalStandardPrice = isUpsellChecked && standardPrice ? standardPrice + ADDON_VALUE : standardPrice;

    const handleBookClick = () => {
        const addons = isUpsellChecked ? ['Full Face Curation'] : [];
        onBook(packageId, addons);
    };

    return (
        <div className="package-card founding-member-card">
            <div className="package-title">{title}</div>
            <div className="card-header">{header}</div>
            <div className="card-price-container">
                <span className="current-price">${finalPrice}</span>
                {finalStandardPrice && <span className="original-price">(Standard: ${finalStandardPrice})</span>}
            </div>
            <p className="card-description">{description}</p>

            <ul className="package-services">
                {services.map((service, index) => (
                    <li key={index}>{service}</li>
                ))}
            </ul>

            {hasUpsell && (
                <div className="upsell-container">
                    <label className="upsell-label">
                        <input
                            type="checkbox"
                            checked={isUpsellChecked}
                            onChange={handleToggle}
                        />
                        <span className="upsell-text">
                            Add Full Face Curation (+${ADDON_PRICE} <span style={{ textDecoration: 'line-through', opacity: 0.7, fontSize: '0.9em' }}>${ADDON_VALUE}</span>)
                        </span>
                    </label>
                </div>
            )}

            <button className="btn full-width package-btn" onClick={handleBookClick}>
                Book for ${finalPrice}
            </button>
        </div>
    );
};

const packages = [
    {
        title: "THE POLISHED PROFESSIONAL",
        header: "Upper Body Visibility",
        price: 79,
        standardPrice: 125,
        description: "Designed for visibility. Perfect for video calls and social confidence.",
        services: ["Full Face Curation", "Full Arm Smoothing", "Underarm Velvet"],
        hasUpsell: false,
        packageId: "pkg_polished_professional",
    },
    {
        title: "THE FIRST IMPRESSION",
        header: "Full Body Silk",
        price: 104,
        standardPrice: 140,
        description: "Our volume leader. A complete texture reset for arms and legs.",
        services: ["Full Leg Smoothing", "Full Arm Smoothing", "Underarm Velvet"],
        hasUpsell: true,
        packageId: "pkg_first_impression",
    },
    {
        title: "THE ESSENTIAL SANCTUARY",
        header: "Total Body Reset",
        price: 149,
        standardPrice: 200,
        description: "The gold standard of hygiene and comfort. Every major zone, handled.",
        services: ["The Brazilian", "Full Leg Smoothing", "Full Arm Smoothing", "Underarm Velvet"],
        hasUpsell: true,
        packageId: "pkg_essential_sanctuary",
    }
];

export const FoundingMemberModal = () => {
    const [isVisible, setIsVisible] = useState(() => {
        // Only show once per session
        return !sessionStorage.getItem('glaminant_modal_dismissed');
    });
    const navigate = useNavigate();

    const handleClose = () => {
        sessionStorage.setItem('glaminant_modal_dismissed', 'true');
        setIsVisible(false);
    };

    const handleBook = (packageId, addons) => {
        handleClose();
        navigate('/book');
    };

    if (!isVisible) return null;

    return (
        <div className="packages-modal-overlay">
            <div className="packages-modal-content">
                <button className="modal-close-btn" onClick={handleClose}>×</button>
                <div className="product-packages-modal">
                    <h2>Founding Member Privileges</h2>
                    <p className="section-subtitle" style={{ textAlign: 'center' }}>Exclusive introductory curations. Experience the luxury of time at insider rates.</p>
                    <div className="packages-stack">
                        {packages.map((pkg, index) => (
                            <PackageCard key={index} {...pkg} onBook={handleBook} />
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

const ProductPackages = () => {
    const navigate = useNavigate();

    const handleBook = (packageId, addons) => {
        localStorage.setItem(PENDING_BOOKING_KEY, JSON.stringify({ packageId, addons }));
        navigate('/book');
    };

    return (
        <section className="founding-members-section section">
            <div className="container">
                <h2>The Founding Member Access</h2>
                <p className="section-subtitle">Exclusive introductory curations. Experience the luxury of time at insider rates.</p>
                <div className="packages-grid">
                    {packages.map((pkg, index) => (
                        <PackageCard key={index} {...pkg} onBook={handleBook} />
                    ))}
                </div>
            </div>
        </section>
    );
};

export default ProductPackages;
